import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Loading from './Loading';
import { clearAPICache } from '@/utils/cacheUtils';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

interface ProtectedRouteProps {
    children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    const isOfflineMode = useSelector((state: RootState) => state.offline.isOfflineMode);

    if (isLoading) {
        // Still checking authentication status
        return <Loading />;
    }

    // Allow access to any routes if in offline mode
    if (isOfflineMode || location.pathname.includes('/offline')) {
        return <>{children}</>;
    }

    if (!isAuthenticated) {
        // Clear cache before redirecting
        clearAPICache();

        // Redirect to login page
        return <Navigate to="/login?forceClear=true" replace state={{ from: location }} />;
    }

    return <>{children}</>;
} 